module.exports = __webpack_public_path__ + "media/images/swiss_cross-c1e8dde1d02a8d9a995c8e74656b39ea.png";